import React, { useCallback, useRef, useState } from 'react';
import ArrowBroadUnderbarDown from '@splunk/react-icons/ArrowBroadUnderbarDown';
import { _ } from '@splunk/ui-utils/i18n';
import { ExportVisualizationModal } from '@splunk/dashboard-ui';
import { exportButtonClicked, useDispatch } from '@splunk/dashboard-state';
import type { BaseButtonProps } from '../BaseButton';
import { ActionButton } from '../ActionButton';
import { RENDER_ACTION_BUTTON_DENYLIST } from '../utils/displayUtils';
import { getButtonTitle } from '../utils/getButtonTitle';

const exportIcon = <ArrowBroadUnderbarDown />;

export const ExportButton = ({
    dashboardApi,
    screenReaderText,
    itemDefinition,
    itemId,
    ...rest
}: BaseButtonProps) => {
    const dispatch = useDispatch();
    const [open, setOpen] = useState(false);
    const buttonRef = useRef<HTMLButtonElement>(null);

    const handleModalClose = useCallback(() => setOpen(false), []);

    const handleOnClick = useCallback(() => {
        dispatch(exportButtonClicked({ type: itemDefinition?.type }));

        setOpen(true);
    }, [dispatch, itemDefinition]);

    const buttonTitle = getButtonTitle({
        base: _('Export'),
        screenReaderText,
    });

    const isValidExportButton =
        itemDefinition &&
        dashboardApi &&
        itemId &&
        !RENDER_ACTION_BUTTON_DENYLIST.includes(itemDefinition.type);

    if (!isValidExportButton) {
        return null;
    }

    return (
        <>
            <ActionButton
                {...rest}
                elementRef={buttonRef}
                data-test="export-button"
                onClick={handleOnClick}
                icon={exportIcon}
                title={buttonTitle}
            />
            <ExportVisualizationModal
                open={open}
                onModalClose={handleModalClose}
                itemDefinition={itemDefinition}
                dashboardApi={dashboardApi}
                itemId={itemId}
                returnFocus={buttonRef}
            />
        </>
    );
};
